import cn from "classnames";
import { TextAlignment } from "@/constants/content";
import { TextAlignmentClassName } from "@/constants/style";

export function getTextAlignmentClassName(alignment: TextAlignment) {
  return cn({
    [TextAlignmentClassName.Left]: alignment === TextAlignment.Left,
    [TextAlignmentClassName.Center]: alignment === TextAlignment.Center,
    [TextAlignmentClassName.Right]: alignment === TextAlignment.Right,
    [TextAlignmentClassName.Justify]: alignment === TextAlignment.Justify,
  });
}
